import { Skeleton } from "@mui/material";
import { UserSettingsSkeletonSectionContainer } from "components/Preferences/UserSettings/UserSettingsSkeleton.styles.ts";
import InfoBanner from "components/Common/InfoBanner/InfoBanner.tsx";
import { AdminAccessText, AdministratorAccessOnly, CommunicationSettingsText } from "components/Preferences/text.ts";

const UserSettingsSkeleton = () => {
	return (
		<UserSettingsSkeletonSectionContainer>
			<div>{CommunicationSettingsText}</div>
			<Skeleton
				variant="text"
				width="100%"
				height="300px"
			/>
			<InfoBanner
				title={AdministratorAccessOnly}
				bodyText={AdminAccessText}
			/>
			<Skeleton
				variant="text"
				width="100%"
				height="128px"
			/>
		</UserSettingsSkeletonSectionContainer>
	);
};

export default UserSettingsSkeleton;
